import { useMemo, useState } from 'react';
import { BillsContext } from './BillsContext';
import { IBill } from '../../../../models/Bills.interfaces';
import { AxiosError } from 'axios';

const BillsProvider = ({ children }: { children: React.ReactNode }) => {
    const [bills, setBills] = useState<IBill[]>([]);
    const [billsToDownload, setBillsToDownload] = useState<Set<string>>(new Set());
    const [isDownloadCompleted, setIsDownloadCompleted] = useState(false);
    const [billsDownloaded, setBillsDownloaded] = useState<string[]>([]);
    const [billsWithError, setBillsWithError] = useState<string[]>([]);
    const [downloadError, setDownloadError] = useState<AxiosError | null>(null);
    const [billsZip, setBillsZip] = useState<Blob | null>(null);

    const value = useMemo(
        () => ({
            bills,
            billsToDownload,
            isDownloadCompleted,
            billsDownloaded,
            billsWithError,
            downloadError,
            billsZip,
            setBills,
            setBillsToDownload,
            setIsDownloadCompleted,
            setBillsDownloaded,
            setBillsWithError,
            setDownloadError,
            setBillsZip,
        }),
        [bills, billsToDownload, isDownloadCompleted, billsDownloaded, billsWithError, downloadError, billsZip],
    );

    return <BillsContext.Provider value={value}>{children}</BillsContext.Provider>;
};

export default BillsProvider;
